// no-spec-needed: server-side access-code gate for the login page
'use client';

import { c as _c } from "react/compiler-runtime";
import { withBasePath } from '@fpo3/ts-commons-core/base-path';
import { useState } from 'react';
import { SignInButton } from '@/components/sign-in-button';
import { Button } from '@/components/ui/button';

/** Render the access-code gate until the server confirms the user can sign in. */
export function GatedSignIn(t0) {
  const $ = _c(16);
  const {
    gateUnlocked
  } = t0;
  const [unlocked, setUnlocked] = useState(gateUnlocked);
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  let t1;
  if ($[0] !== code) {
    t1 = async e => {
      e.preventDefault();
      try {
        const response = await fetch(withBasePath("/api/auth/gate"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            code
          })
        });
        if (response.ok) {
          setUnlocked(true);
          setError(false);
        } else {
          setError(true);
        }
      } catch {
        setError(true);
      }
    };
    $[0] = code;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSubmit = t1;
  if (unlocked) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <SignInButton />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <label htmlFor="gate-code" className="text-sm text-muted-foreground">Enter access code</label>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e_0 => {
      setCode(e_0.target.value);
      setError(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== code) {
    t4 = <input id="gate-code" type="text" value={code} onChange={t3} placeholder="Code" autoFocus={true} className="rounded-md border border-input bg-background px-3 py-2 text-base md:text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" />;
    $[5] = code;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button type="submit">Enter</Button>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <div className="flex gap-2">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== error) {
    t7 = error && <p className="text-sm text-destructive">Incorrect code</p>;
    $[10] = error;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleSubmit || $[13] !== t6 || $[14] !== t7) {
    t8 = <form onSubmit={handleSubmit} className="flex flex-col items-center gap-3">{t2}{t6}{t7}</form>;
    $[12] = handleSubmit;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}